import { Directive, input } from '@angular/core';
import { BrnFieldControlDescribedBy } from '@spartan-ng/brain/field';
import { BrnInput } from '@spartan-ng/brain/input';
import { classes } from '@lite-workspace/shared/helm-ui/utils';
import { cva, type VariantProps } from 'class-variance-authority';

export const inputVariants = cva(
  'dark:bg-input/30 border-input focus-visible:border-ring focus-visible:ring-ring data-[matches-spartan-invalid=true]:ring-destructive data-[matches-spartan-invalid=true]:border-destructive dark:data-[matches-spartan-invalid=true]:border-destructive/50 rounded-md border bg-transparent px-2.5 py-1 text-base shadow-xs transition-[color,box-shadow] file:h-7 file:text-sm file:font-medium focus-visible:ring-1 data-[matches-spartan-invalid=true]:ring-1 md:text-sm max-md:text-base text-foreground file:text-foreground placeholder:text-muted-foreground w-full min-w-0 outline-none file:inline-flex file:border-0 file:bg-transparent disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      size: {
        sm: 'h-8',
        default: 'h-9',
        lg: 'h-10.5',
      },
    },
    defaultVariants: { size: 'default' },
  },
);

export type InputVariants = VariantProps<typeof inputVariants>;

@Directive({
  selector: '[hlmInput]',
  // `aria-describedby` is exposed on purpose: unexposed, a template binding writes the raw
  // attribute while the directive's own host binding overwrites it with its computed null.
  hostDirectives: [
    { directive: BrnInput, inputs: ['id', 'forceInvalid'] },
    { directive: BrnFieldControlDescribedBy, inputs: ['aria-describedby'] },
  ],
  host: { 'data-slot': 'input' },
})
export class HlmInput {
  // Shadows the native `<input size>` attribute; matches HlmButton's axis name.
  public readonly size = input<InputVariants['size']>('default');

  constructor() {
    classes(() => inputVariants({ size: this.size() }));
  }
}
